import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-60 min-h-36 rounded-2xl bg-white shadow-lg shadow-gray-500 pt-4 pb-7 px-4 select-none" }
const _hoisted_2 = { class: "flex flex-row justify-start pl-2 pr-2 pb-3 gap-2" }
const _hoisted_3 = { class: "capitalize" }

import { ref } from 'vue';
import { WorkflowTask } from '@/http/workflowTask';
import { Handle, NodeProps, Position } from '@vue-flow/core';
import { Textarea } from '../ui/textarea';
import WorkflowTaskIcon from './WorkflowTaskIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextNode',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: [Boolean, Number, String, Function] },
    position: {},
    dimensions: {},
    label: {},
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    parent: {},
    parentNodeId: {},
    dragging: { type: Boolean },
    resizing: { type: Boolean },
    zIndex: {},
    targetPosition: {},
    sourcePosition: {},
    dragHandle: {},
    data: {},
    events: {}
  },
  setup(__props: any) {

const props = __props;
const messageTextContent = ref(props.data.content);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(WorkflowTaskIcon, {
          workflowTaskType: props.data.type,
          workflowTaskSubtype: props.data.interactiveSubtype
        }, null, 8, ["workflowTaskType", "workflowTaskSubtype"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(props.data.type.toLocaleLowerCase()), 1)
      ]),
      _createVNode(_unref(Textarea), {
        class: "rounded-xl bg-white resize-none",
        placeholder: "Digite sua mensagem...",
        name: "mensagem",
        rows: "4",
        modelValue: messageTextContent.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageTextContent).value = $event)),
        readonly: true
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_R`,
      type: "target",
      position: _unref(Position).Right
    }, null, 8, ["id", "position"]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_L`,
      type: "source",
      position: _unref(Position).Left
    }, null, 8, ["id", "position"]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_T`,
      type: "target",
      position: _unref(Position).Top
    }, null, 8, ["id", "position"]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_B`,
      type: "source",
      position: _unref(Position).Bottom
    }, null, 8, ["id", "position"])
  ], 64))
}
}

})